<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  <div>
    <img class="w-[53px] h-[53px]" src="/assets/v4/icon-airbnb-color-bg.svg" alt="" />
    <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
    <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
  </div>

  <div class="text-l font-bold mt-[30px]">
    {{ "channel-connect_airbnb_html_标题" | translate }}
    <!-- Connect with Airbnb -->
  </div>

  <div class="text-m mt-[30px]">
    {{ "channel-connect_airbnb_html_说明" | translate }}
    <!-- Hostex is an official Airbnb connectivity partner, so we can connect with your account reliably and securely. -->
  </div>

  <div class="text-m mt-[30px]">
    <div>
      {{ "channel-connect_airbnb_html_注意事项" | translate }}
      <!-- Before you start connecting, you need to know the following things. -->
    </div>
    <ol>
      <li>
        {{ "channel-connect_airbnb_html_注意事项1" | translate }}
        <!-- 1. Make sure you are currently logged into the account you want to connect to. -->
      </li>
      <li>
        {{ "channel-connect_airbnb_html_注意事项4_1" | translate }}
        <a href="javascript:void(0)" (click)="toOuterLink()" target="_blank">{{
          "channel-connect_airbnb_html_注意事项4_2" | translate
        }}</a>
        {{ "channel-connect_airbnb_html_注意事项4_3" | translate }}
        <!-- 1. Make sure you are currently logged into the account you want to connect to. -->
      </li>
      <li>
        {{ "channel-connect_airbnb_html_注意事项2" | translate }}
        <!-- 2. After connection, some settings must be set via Hostex, e.g. Cleaning fee. -->
      </li>
      <li>
        {{ "channel-connect_airbnb_html_注意事项3" | translate }}
        <!-- 3. After connection, you can enable your Airbnb listing to support multi-inventory. -->
      </li>
    </ol>
  </div>

  <div [class]="footerClass">
    <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
      {{ "word.cancel" | translate }}
      <!-- Cancel -->
    </button>
    <button [class]="footerConfirmBtnClass" nz-button nzType="primary" nzSize="large" (click)="onAuth()">
      {{ "channel-connect_booking_html_我明白了" | translate }}
      <!-- I understand and want to connect -->
    </button>
  </div>
</div>
